/**
 * Fetch helpers with axios-compatible success shape `{ data }` and errors `{ response: { status, data } }`.
 */

async function parseBody(res) {
	const text = await res.text();
	if (!text) return null;
	try {
		return JSON.parse(text);
	} catch {
		return text;
	}
}

function appendQueryParams(url, params) {
	if (!params || !Object.keys(params).length) return url;
	const sp = new URLSearchParams();
	for (const [key, value] of Object.entries(params)) {
		if (value !== undefined && value !== null) sp.append(key, String(value));
	}
	const sep = url.includes('?') ? '&' : '?';
	return `${url}${sep}${sp.toString()}`;
}

function axiosStyleError(res, data) {
	const msg =
		typeof data === 'object' && data !== null && data.message
			? data.message
			: res.statusText || 'Request failed';
	const err = new Error(msg);
	err.response = { status: res.status, data: data ?? {} };
	return err;
}

export function apiGet(url, params) {
	const finalUrl = appendQueryParams(url, params);
	return fetch(finalUrl, { method: 'GET', credentials: 'same-origin' }).then(async (res) => {
		const data = await parseBody(res);
		if (!res.ok) throw axiosStyleError(res, data);
		return { data, status: res.status };
	});
}

export function apiPost(url, body, requestOptions = {}) {
	const { headers: extraHeaders = {} } = requestOptions;
	const isFormData = body instanceof FormData;
	const headers = { ...extraHeaders };
	if (isFormData) {
		delete headers['Content-Type'];
		delete headers['content-type'];
	} else if (body !== undefined && body !== null) {
		if (!headers['Content-Type'] && !headers['content-type']) {
			headers['Content-Type'] = 'application/json';
		}
	}

	return fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		headers,
		body: isFormData ? body : JSON.stringify(body)
	}).then(async (res) => {
		const data = await parseBody(res);
		if (!res.ok) throw axiosStyleError(res, data);
		return { data, status: res.status };
	});
}
